export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500">
              <div className="w-full h-[500px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20colorful%20Pakistani%20cafe%20interior%20with%20vibrant%20truck%20art%20inspired%20wall%20murals%2C%20comfortable%20seating%20area%20with%20orange%20and%20teal%20cushions%2C%20warm%20lighting%2C%20customers%20enjoying%20food%2C%20welcoming%20atmosphere%20with%20traditional%20Pakistani%20decorative%20elements%20and%20contemporary%20design&width=600&height=700&seq=about1&orientation=portrait"
                  alt="EatSpot Cafe Interior"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-orange-500/20 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-500/20 rounded-full blur-2xl"></div>
          </div>

          {/* Content Side */}
          <div className="relative pl-0 lg:pl-12">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-orange-500 hidden lg:block"></div>
            
            <div className="mb-6">
              <span className="text-orange-500 font-semibold text-sm tracking-widest uppercase">Our Story</span>
            </div>
            
            <h2 className="text-5xl font-bold text-amber-900 mb-6 leading-tight">
              EatSpot brings the authentic taste{' '}
              <span className="text-gray-500">of Pakistani street food with a modern café twist</span>
            </h2>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              At EatSpot, we celebrate the rich flavors of Pakistani cuisine with a contemporary approach. 
              Every dish is prepared fresh daily using authentic recipes and quality ingredients. From our 
              signature bun kebabs to refreshing lassi, we bring you the taste of home in a vibrant, 
              welcoming atmosphere.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed mb-10">
              Located in the heart of F-7 Markaz, Islamabad, we're your go-to spot for quick bites, 
              hearty meals, and sweet treats. Whether you're grabbing lunch on the go or meeting friends 
              for coffee, EatSpot delivers delicious food with a smile.
            </p>

            {/* Feature Badges */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-restaurant-2-fill text-3xl text-orange-500"></i>
                </div>
                <p className="text-sm font-semibold text-amber-900">Fresh Daily</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-fill text-3xl text-green-600"></i>
                </div>
                <p className="text-sm font-semibold text-amber-900">Halal Certified</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-leaf-fill text-3xl text-teal-600"></i>
                </div>
                <p className="text-sm font-semibold text-amber-900">Local Ingredients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
